/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import ROUTES from '@constants/routes';
import { COL_WITH_EXTRA } from '@constants';

import PageSelect from '../PageSelect';

const PageField = React.forwardRef(
  (
    {
      initialParentPage,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      filterList,
      ...props
    },
    ref,
  ) => {
    const [selectedPage, setSelectedPage] = React.useState(initialParentPage);
    const { locale } = props;
    const pageId = selectedPage?.contentId || selectedPage?.id;
    const languageInUrl = locale ? `/${locale}` : '';

    const handleChange = (page) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(page);
      setSelectedPage(page);
    };

    return (
      <Form.ItemWithExtra
        wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
        extra={
          !!selectedPage && (
            <Link to={`${ROUTES.PAGES}/${pageId}${languageInUrl}`} target="_blank" rel="noopener noreferrer">
              Series setup
            </Link>
          )
        }
        {...props}
      >
        <PageSelect
          ref={ref}
          onChange={handleChange}
          disabled={disabled}
          onSearch={onSearch}
          showAction={showAction}
          placeholder={placeholder}
          queryVariables={queryVariables}
          filterList={filterList}
        />
      </Form.ItemWithExtra>
    );
  },
);

export default PageField;
